import { Select } from "components/Select";

export type ShipmentSidebarView = ShipmentRelation | "quotes";

interface Props {
  onShipmentRelationChange: (value: ShipmentRelation) => void;
  onQuotesSelected: VoidFunction;
  value: ShipmentSidebarView;
}

const SHIPMENT_SIDEBAR_VIEW_OPTIONS = [
  { value: "partner" as ShipmentSidebarView, label: "Partner Shipments" },
  { value: "public" as ShipmentSidebarView, label: "Public Shipments" },
  { value: "quotes" as ShipmentSidebarView, label: "My Quotes" },
];

export function ShipmentSidebarViewDropdown(props: Props) {
  const { onShipmentRelationChange, onQuotesSelected, value } = props;

  const handleChange = (newValue: ShipmentSidebarView) => {
    if (newValue === "quotes") {
      onQuotesSelected();
    } else {
      onShipmentRelationChange(newValue);
    }
  };

  return (
    <Select
      inputLabel=""
      options={SHIPMENT_SIDEBAR_VIEW_OPTIONS}
      onChange={handleChange}
      defaultValue="partner"
      value={value}
    />
  );
}
